import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import {
  useAdminSignupQuestionQuery,
  useAdminUpdateSignupQuestionMutation,
} from '../../../features/admin/hooks/use-admin-api'
import { SignupQuestionForm } from '../../../features/signup-question/components/signup-question-form'

export const Route = createFileRoute('/admin/signup-question/')({
  component: Page,
})

function Page() {
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null)
  const questionQuery = useAdminSignupQuestionQuery()
  const updateMutation = useAdminUpdateSignupQuestionMutation()

  const question = questionQuery.data?.data

  const showMessage = (kind: 'success' | 'error', text: string) => {
    setMessage({ type: kind, text })
    setTimeout(() => setMessage(null), 3000)
  }

  if (questionQuery.isLoading) {
    return (
      <div className="flex h-48 items-center justify-center text-muted-foreground">Loading...</div>
    )
  }

  if (!question) {
    return (
      <div className="flex h-48 items-center justify-center text-muted-foreground">
        Sign-up question not found
      </div>
    )
  }

  return (
    <div className="mx-auto w-full max-w-4xl">
      <SignupQuestionForm
        config={question.config}
        isSaving={updateMutation.isPending}
        onSave={(config) =>
          updateMutation.mutate(
            { body: { config } },
            {
              onSuccess: () => showMessage('success', 'Saved'),
              onError: () =>
                showMessage('error', 'Failed to save. Check that every option has a label.'),
            }
          )
        }
      />

      {message && (
        <div
          className={`fixed bottom-6 right-6 rounded-lg px-4 py-2.5 text-sm font-medium shadow-lg ${
            message.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'
          }`}
        >
          {message.text}
        </div>
      )}
    </div>
  )
}
